import DeleteOrgCtrl from './DeleteOrgCtrl';
import modalDeleteOrgUrl from './modal-delete-org.html';
import { BUSINESS_CATEGORIES, OTHER_BUSINESS_CATEGORY } from './constants';

class AccountCtrl {
  businessCategories = BUSINESS_CATEGORIES.map((cat) => ({ label: cat, value: cat }));
  OTHER_BUSINESS_CATEGORY = OTHER_BUSINESS_CATEGORY;

  constructor(Authentication, $uibModal, customIndustryName, billingInfo) {
    'ngInject';

    Object.assign(this, { Authentication, $uibModal, customIndustryName, billingInfo });
    this.originalCustomIndustryName = customIndustryName;
    this._resetForm();
  }

  _resetForm() {
    this.customIndustryName = this.originalCustomIndustryName;
    this.organizationName = this.Authentication.user.org.name;
    this.businessCategory = this.Authentication.user.org.businessCategory;

    if (this.form) {
      this.form.$setPristine();
    }
  }

  cancel() {
    this._resetForm();
  }

  async submit() {
    if (this.form?.$invalid) {
      this.form?.$setSubmitted();
      throw 'invalid form';
    }

    await this.Authentication.updateOrg({
      name: this.organizationName,
      businessCategory: this.businessCategory,
      customIndustry: this.customIndustryName,
    });
    this.originalCustomIndustryName = this.customIndustryName;

    this._resetForm();
  }

  deleteOrg() {
    const { billingInfo } = this;
    return this.$uibModal
      .open({
        name: 'DeleteOrgCtrl',
        templateUrl: modalDeleteOrgUrl,
        controller: DeleteOrgCtrl,
        controllerAs: 'ctrl',
        size: '620',
        resolve: {
          billingInfo() {
            return billingInfo;
          },
        },
      })
      .result.ignoreCancel();
  }
}

export default AccountCtrl;
